<template>
  <GroupBase>
    <p class="text-muted fs-6 text-center">Explore and find existing groups to join.</p>

    <SearchBox
      :placeholder.once="'Type a name or email.'"
      :value.sync="name"
      :search="fetchColleagueSearchResults"/>

    <Loader v-if="showLoader"/>

    <GroupElement
      v-for="group in results"
      :key="group.id"
      :id="group.id"
      :name="group.name"
      :privacySetting="group.privacy_setting"
      :requested="group.requested"
      :isMember="group.is_member"
      />

    <div v-if="!initialState && results.length === 0">No search results found!</div>
  </GroupBase>
</template>

<script>
import Loader from './Loader.vue'
import GroupBase from './GroupBase'
import SearchBox from './SearchBox'
import GroupElement from './GroupElement'
import { generalErrorHandler } from '../actionTypes'

import store from '../store'

import axios from 'axios'

export default {
  name: 'FindGroups',
  components: {
    GroupBase,
    Loader,
    SearchBox,
    GroupElement,
  },
  data () {
    return {
      results: [],
      showLoader: false,
      name: '',
      initialState: true,
      privacy: ['blank', 'public', 'closed', 'private'],
    }
  },
  methods: {
    close () {
      this.results = []
      this.$emit('close')
    },
    fetchColleagueSearchResults () {
      this.showLoader = true
      this.initialState = false
      return axios.get('/api/v1/usergroups/?search=' + this.name,
        { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } })
      .then(response => {
        this.results = response.data
        this.showLoader = false
      })
      .catch(error => {
        store.dispatch(generalErrorHandler, { error, customMessage: 'Problem fetching results.' })
        this.showLoader = false
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// FindGroups.vue?844daf2e